import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const FTRow = ({
    item,
    index,
    lastRow,
    singleRow,
    hasBetOrdering,
    modalTitle,
    modalText,
    identifier,
    raceTime,
    textContent,
    asideContent,
    classBlockName,
    outcomersId,
    renderIndexContent,
    renderAsideContent,
}) => {
    const classBlock = identifier !== '' ? `${classBlockName}-${identifier}` : classBlockName;

    return (
        <div className={`${classBlock}`}>
            {!singleRow ?
                <div className={`${classBlock}__index`}>
                    {renderIndexContent(
                        classBlock,
                        identifier,
                        hasBetOrdering,
                        index,
                        raceTime,
                        modalTitle,
                        modalText)}
                </div> :
                ''
            }
            <div
                className={`${classBlock}__text`}
                title={identifier === 'selection' ? textContent : ''}
            >
                <span className={`${classBlock}__text-content`}>
                    {textContent}
                </span>
            </div>
            {!singleRow ?
                <div className={`${classBlock}__aside`}>
                    {renderAsideContent(
                        item,
                        classBlock,
                        identifier,
                        hasBetOrdering,
                        asideContent,
                        index,
                        lastRow,
                        outcomersId)}
                </div> :
                ''
            }
        </div>
    );
}

FTRow.defaultProps = {
    item: {},
    singleRow: false,
    outcomersId: '',
    index: -1,
    lastRow: false,
    hasBetOrdering: true,
    modalTitle: '',
    modalText: '',
    identifier: 'selection',
    raceTime: '',
    textContent: '',
    asideContent: '',
    classBlockName: 'bs-ft-row',
    renderIndexContent: () => {},
    renderAsideContent: () => {},
};

FTRow.propTypes = {
    item: PropTypes.shape({}),
    singleRow: PropTypes.bool.isRequired,
    outcomersId: PropTypes.string,
    index: PropTypes.number,
    lastRow: PropTypes.bool,
    hasBetOrdering: PropTypes.bool,
    modalTitle: PropTypes.string,
    modalText: PropTypes.string,
    identifier: PropTypes.string.isRequired,
    raceTime: PropTypes.string,
    textContent: PropTypes.string.isRequired,
    asideContent: PropTypes.string,
    classBlockName: PropTypes.string,
    renderIndexContent: PropTypes.func.isRequired,
    renderAsideContent: PropTypes.func.isRequired,
};

export default FTRow;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/FTForm/components/FTRow/FTRow.jsx